<photosphere [isBack]="true" [nurseryUUID]="nurseryUUID" [sphereUUID]="sphereUUID"></photosphere>
